// extracted by mini-css-extract-plugin
export default {"main-content":"styles_main-content__IitKP","heading--level-1":"styles_heading--level-1__UB9hh","action-button":"styles_action-button__CV58Q"};